/*
0(togo-pickup-order), 2(catering-delivery-order), 3(catering-delivery-order)
*/
export var SocialMediaType;

(function (SocialMediaType) {
  SocialMediaType["FACEBOOK"] = "facebook";
  SocialMediaType["GOOGLEPLUS"] = "googleplus";
  SocialMediaType["APPLE"] = "apple";
})(SocialMediaType || (SocialMediaType = {}));

export var ERecentTimeSelectionFromAPI;

(function (ERecentTimeSelectionFromAPI) {
  ERecentTimeSelectionFromAPI["LOCATION_CONFIRMATION_API"] = "LOCATION_CONFIRMATION_API";
  ERecentTimeSelectionFromAPI["SET_PICKUP_TIME_API"] = "SET_PICKUP_TIME_API";
  ERecentTimeSelectionFromAPI["FETCH_TIME_API"] = "FETCH_TIME_API";
  ERecentTimeSelectionFromAPI["SESSION_DETAILS"] = "SESSION_DETAILS";
})(ERecentTimeSelectionFromAPI || (ERecentTimeSelectionFromAPI = {}));